import * as React from 'react';
import { observer } from 'mobx-react';
import SharedRowColumns from '../SharedRowColumns';
import { NotTranslated } from '@execonline-inc/translations';
import { FailedParticipant, SuccessfulParticipant } from '../../Store/Types';

interface Props {
  participant: SuccessfulParticipant | FailedParticipant;
}

const Row: React.FC<Props> = ({ participant }) => {
  const errorMessage = () => {
    switch (participant.kind) {
      case 'failed':
        return (
          <td className="text-red whitespace-nowrap px-3 py-4 text-sm text-rose-500">
            <NotTranslated text={participant.errorMessage} />
          </td>
        );

      case 'successful':
        return <td></td>;
    }
  };

  return (
    <tr>
      <SharedRowColumns
        firstname={participant.firstName}
        lastname={participant.lastName}
        email={participant.email}
      />
      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
        <NotTranslated text={participant.kind} />
      </td>
      {errorMessage()}
    </tr>
  );
};

export default observer(Row);
